import { WORKFLOW_REPORT_SKILL_SLUG } from '@digital-twins/shared-types'
import { AssistantTurnPlanTail } from '@/lib/api/client'

import { REPORT_COMMAND_SLUG } from './useThreadCommands'

/**
 * The plan skill step that report mode owns. Nest is the authority on what a
 * report turn is (`mode === 'report'` or this step's skill slug); this file
 * only decides that a plan holding nothing else has no card worth showing.
 */
export const REPORT_WRITING_SKILL_SLUG = WORKFLOW_REPORT_SKILL_SLUG

/**
 * Single-step workflow plans never render a Suggested plan card — route into
 * ThreadCommandSeed confirm (same path as plan-card Start). Skills stay
 * chat-only.
 *
 * Every plan tail has already been projected from the registry, so any
 * one-step workflow may open its ordinary confirmation gate. Spend and Slack
 * checks remain at their respective run gates.
 *
 * ONE EXCEPTION among skills: a lone `report-writing` step. `/report` stopped
 * being a workflow when report mode landed
 * (`docs/plans/2026-09-03-assistant-report-mode.md`, D1 and D10), so the plan
 * that used to close a twin test with a `thread-action-report` workflow step
 * now closes it with this skill. It is the same beat the reader already asked
 * for, so it takes the same card skip and seeds the same command — which for
 * `/report` arms the scoping intake rather than opening a confirm screen.
 */
export function singleStepWorkflowSlug(
  plan: AssistantTurnPlanTail,
): string | null {
  if (plan.cardEligible || plan.steps.length !== 1) {
    return null
  }
  const step = plan.steps[0]
  if (step.kind === 'skill') {
    return step.slug === REPORT_WRITING_SKILL_SLUG ? REPORT_COMMAND_SLUG : null
  }
  if (step.kind !== 'workflow' || !step.slug) {
    return null
  }
  return step.slug
}
